import { useMemo, type PropsWithChildren } from "react";

import {
  type SingleFightDetailsData,
  SingleFlightSelectionContext,
} from "./SingleFlightDetailsContext";

type Props = PropsWithChildren<{
  data: SingleFightDetailsData;
  isAdditionalDataLoading?: boolean;
}>;

export const SingleFlightDetailsProvider = ({
  data,
  isAdditionalDataLoading,
  children,
}: Props) => {
  const departureFlight = data?.flights?.[0] ?? null;
  const returnFlight =
    ((data?.flights?.length || 0) > 1 &&
      data?.flights?.[data?.flights.length - 1]) ||
    null;

  const contextValue = useMemo(
    () => ({
      singleFlightDetails: data,
      departureFlight,
      returnFlight,
      isAdditionalDataLoading: isAdditionalDataLoading || false,
    }),
    [data, departureFlight, isAdditionalDataLoading, returnFlight],
  );

  return (
    <SingleFlightSelectionContext.Provider value={contextValue}>
      {children}
    </SingleFlightSelectionContext.Provider>
  );
};
